export default __webpack_public_path__ + "64700181225896507d8875c0f16e0722.png";